module.exports = __webpack_public_path__ + "img/user-shield-solid.6ebcd811.svg";